<template>
  <div>
    <h1>{{ $t("userSubstitute.title") }}</h1>
    <delegation-substitutes-menu />
    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <div>
        <user-substitute-form @saved="load">
          <v-btn block color="accent">{{ $t("userSubstitute.addNew") }}</v-btn>
        </user-substitute-form>
      </div>
    </v-row>
    <v-data-table :headers="headers" :items="substitutes" :search="search" :loading="$store.getters['Ajax/loading'] ? 'accent' : false">
      <template #item="props">
        <tr>
          <td class="text-left">{{ props.item.absent_user_name }}</td>
          <td class="text-left">{{ props.item.substitute_user_name }}</td>
          <td class="text-left">
            {{ props.item.from_date == null ? $t("global.noSetTime") : props.item.from_date }}
          </td>
          <td class="text-left">
            {{ props.item.to_date == null ? $t("global.noSetTime") : props.item.to_date }}
          </td>
          <td class="text-left">{{ props.item.comment }}</td>
          <td class="text-center px-0 text-no-wrap">
            <v-tooltip bottom>
              {{ $t("userSubstitute.logAsAbsentUser") }}
              <template #activator="{on}">
                <v-btn @click="loginAs(props.item)" class="mx-0" icon v-if="props.item.can_login_as" v-on="on">
                  <v-icon color="">transfer_within_a_station</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <user-substitute-form :userSubstitute.sync="props.item" @saved="load" v-if="props.item.can_modify"> </user-substitute-form>
            <v-tooltip bottom>
              {{ $t("global.delete") }}
              <template #activator="{on}">
                <v-btn @click.native="remove(props.item)" icon v-if="props.item.can_modify" v-on="on">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
//    import VehicleDialog from './VehicleDialog.vue';
import UserSubstituteForm from "../../components/UserSubstitute/UserSubstituteForm";
import DelegationSubstitutesMenu from "../../components/DelegationSubstitutesMenu"; // webpack alias

export default {
  name: "SubstitutesView",
  components: { DelegationSubstitutesMenu, UserSubstituteForm },
  data: () => ({
    search: "",
    substitutes: []
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("userSubstitute.absentUser"),
          value: "absent_user_name"
        },
        {
          text: this.$t("userSubstitute.substituteUser"),
          value: "substitute_user_name"
        },
        { text: this.$t("userSubstitute.fromTime"), value: "from_date" },
        { text: this.$t("userSubstitute.toTime"), value: "to_date" },
        { text: this.$t("global.comment"), value: "comment" },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    }
    // vehicles: function () {
    //     return this.$store.getters['Vehicle/vehicleList'];
    // }
  },
  methods: {
    loginAs(item) {
      this.$store
        .dispatch("AUTH_LOGIN_AS", item.absent_user_id)
        .then(() => {
          this.$store.dispatch("alertDialog", {
            content: this.$t("userSubstitute.dialogChangedContext.content"),
            title: this.$t("userSubstitute.dialogChangedContext.title")
          });
        })
        .catch(() => {
          this.$store.dispatch("alertDialog", {
            content: this.$t("userSubstitute.dialogContextChangeFailed.content"),
            title: this.$t("userSubstitute.dialogContextChangeFailed.title")
          });
        });
    },
    load() {
      this.axios.get("user-substitute/substitutes").then(resp => {
        this.substitutes = resp.data;
      });
    },
    remove(item) {
      let dialog = this.$store.dispatch("confirmDialog", {
        content: this.$t("userSubstitute.dialogConfirmRemove.content"),
        title: this.$t("userSubstitute.dialogConfirmRemove.title")
      });
      dialog.then(() => {
        this.axios.post("user-substitute/item-delete", { id: item.id }).then(() => {
          this.load();
          this.$store.dispatch("snackbarPush", {
            text: this.$t("userSubstitute.dialogConfirmRemove.done"),
            position: "down"
          });
        });
      });
    }
  },
  created() {
    this.load();
  }
};
</script>

<style scoped></style>
